const TOOLTIP_CONTENT_ZINDEX = 100;
export {
  TOOLTIP_CONTENT_ZINDEX
};
